import { memo, useMemo } from "react";

import type { RoomStock_StockManagementQuery } from "@/lib/gql/__generated__/graphql";

import { BlankContentForList } from "@/components/features/_components";
import { StockTable } from "@/components/features/items/stock/_shared/components/table";
import { StockTableHeader } from "@/components/features/items/stock/_shared/components/table/header";

import { useRoomStockTablePresenter } from "./hooks/use-room-table-presenter";
import { RoomStockTableRows } from "./rows";

import type { RoomStockDiffStore } from "../../../../../model/usecase/use-create-form-model/room-stock-diff-store";

type Props = {
	serverModel: RoomStock_StockManagementQuery;
	roomStockDiffStore: RoomStockDiffStore;
	selectedItemIDs: string[];
};

export const RoomStockTableForLaptop = memo(({ serverModel, roomStockDiffStore, selectedItemIDs }: Props) => {
	const { filteredViewModel, currentMonth, currentYear } = useRoomStockTablePresenter({
		serverModel,
		selectedItemIDs,
	});

	const { headers, items, hotelID } = filteredViewModel;

	/**
	 * 在庫一覧を表示するか
	 */
	const canShowStockList = useMemo(() => items.length > 0, [items.length]);

	return (
		<StockTable currentYearAndMonth={{ year: currentYear, month: currentMonth }}>
			{canShowStockList ? (
				<>
					<StockTableHeader headers={headers} />
					<RoomStockTableRows items={items} hotelID={hotelID} roomStockDiffStore={roomStockDiffStore} />
				</>
			) : (
				<BlankContentForList content="表示する部屋がありません。" />
			)}
		</StockTable>
	);
});

RoomStockTableForLaptop.displayName = "RoomStockTableForLaptop";
